// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__SV8QU","header":"ErrorPage_header__fqh4l","headerMsg":"ErrorPage_headerMsg__89QYs","content":"ErrorPage_content__ClzEU"};